import './index.scss';

import React from 'react';
import modifiers from "../../../util/components";

class DataValue extends React.Component {
    static defaultProps = {
        title: 'Data value',
        modifiers: null
    };

    render() {
        return (
            <div className={'data-value' + modifiers('data-value', this.props.modifiers)}>
                <div className="data-value__title">
                    {this.props.title}
                </div>
                <div className="data-value__content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default DataValue;